import * as React from "react";
import type { VariantProps } from "class-variance-authority";
import { Button, type ButtonProps } from "@/components/ui/button";
import type { buttonVariants } from "@/components/ui/buttonVariants";

type Props = Omit<ButtonProps, "size"> & {
  label: string;
  variant?: VariantProps<typeof buttonVariants>["variant"];
};

/** Ikon-gomb, mindig magyar (vagy átadott) akadálymentes névvel. */
export const IconButton = React.forwardRef<HTMLButtonElement, Props>(function IconButton(
  { label, children, ...props },
  ref
) {
  return (
    <Button ref={ref} type="button" size="icon" aria-label={label} title={label} {...props}>
      {children}
    </Button>
  );
});
